'use strict';
var unitas = unitas || {};
const timeline = document.querySelector('#js-travel-plan-timeline');
const timelineItems = document.querySelectorAll('.js-travel-plan-timeline-item');
const timelineShowAllTrigger = document.querySelector('#js-travel-plan-timeline-show-all');
const slideshow = document.querySelector('#js-travel-plan-slideshow');
const travelplan = document.querySelector('#js-travel-plan');

unitas.travelplan = unitas.travelplan || function () {
	function init() {
        setupTimeline();
        setupSlideshow();
	}

    function setupTimeline() {
        if(timeline && timelineItems && timelineShowAllTrigger) {
            let threeItemsHeight = 0;

            for (let i = 0; i < timelineItems.length; i++) {
                const currentItem = timelineItems[i];
                const currentItemHeight = currentItem.getBoundingClientRect().height;
                const item = currentItem.getAttribute('data-item');

                if(item <= 2) {
                    threeItemsHeight = threeItemsHeight + currentItemHeight;
                }
            }

            timeline.style.maxHeight = threeItemsHeight + 'px';

            timelineShowAllTrigger.addEventListener('click', function(){
                if(timeline.classList.contains('open')) {
                    timeline.classList.remove('open');
                    timelineShowAllTrigger.classList.remove('open');
                    timeline.style.maxHeight = threeItemsHeight + 'px';

                } else {
                    timeline.classList.add('open');
                    timelineShowAllTrigger.classList.add('open');
                    timeline.style.maxHeight = timeline.scrollHeight + "px";
                }
            });
        }
    }

    function setupSlideshow() {
        // if(window.innerWidth > 992) {
        //     console.log(travelplan.getBoundingClientRect().height);
        //     document.addEventListener('scroll', function(){
        //         console.log(travelplan.scrollHeight);
        //         console.log('window y',window.scrollY);
        //         let timelineRect = timeline.getBoundingClientRect();
        //         let slideshowRect = slideshow.getBoundingClientRect();
        //         // console.log('timeline y + height',timelineRect.y + timelineRect.height);
        //         // console.log('slideshow y',slideshowRect.y + slideshowRect.height);
        //         // console.log('timeline stop at',timelineRect.y + timelineRect.height);

        //         if(timelineRect.y < 100) {
        //             let newTopPos = (timelineRect.y - 100) * -1 + 'px';
        //             slideshow.style.transform = 'translateY(' + newTopPos + ')';
        //         }
        //     });
        // }
        if(slideshow) {
            var flkty = new Flickity( slideshow, {
                // options
                cellAlign: 'left',
                contain: true,
                pageDots: false,
                prevNextButtons: true,
                wrapAround: true,
                cellSelector: '.js-travel-plan-slideshow-slide'
            });
        }
    }

	return {
		init : init
	};
}();